import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Grid2,
  Box,
  Typography,
  Paper,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { getWorkspaces, openWorkspace, removeWorkspace } from "../../actions/workspaceAction";
import { Link, useNavigate } from "react-router-dom";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import AddButton from "../../themes/overrides/AddButton";
import SearchField from "../../themes/overrides/SearchField";
import WorkspaceIcon from "../../assets/images/workspace_black.svg"
import WorkspaceModal from "./WorkspaceModal";
import LoadingOverlay from "../../components/LoadingOverlay";

const WorkspaceList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [shouldRefresh, setShouldRefresh] = useState(true);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const workspaces = useSelector((state) => state.workspace.workspaces);

  useEffect(() => {
    if (shouldRefresh) {
      dispatch(getWorkspaces());
      setShouldRefresh(false);
    }
  }, [shouldRefresh, dispatch]);


  const handleSearch = (event) => {
    setSearchTerm(event.target.value.toLowerCase());
  };

  // const handleNavigate = (workspaceId) => {
  //   dispatch(openWorkspace(workspaceId, navigate));
  // };

  const handleRowClick = async (params) => {
    if (loading) return;
    try {
      setLoading(true)
      const paramId = params.row._id;
      await dispatch(openWorkspace(paramId, navigate));
    } catch (error) {
      console.log('Error loading workspace');
    } finally {
      setLoading(false)
    }
  };

  // const handleManageUsers = () => {
  //   setManageUsersModalOpen(true);
  // }

  // const handleDeleteWorkspace = () => {
  //   setDeleteModalOpen(true);
  // }

  // const handleDeleteConfirm = async () => {
  //   setLoading(true)
  //   try {
  //     await dispatch(removeWorkspace(selectedWorkspace._id))
  //       .then(() => {
  //         setShouldRefresh(true);
  //         setDeleteModalOpen(false);
  //         setSelectedWorkspace(null);
  //       })
  //   } catch (error) {
  //     console.log('Delete failed. Please try again.');
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const columns = [
    { field: "name", headerName: "Workspace Name", flex: 1 },
    { field: "createdBy", headerName: "Owner Name", flex: isMobile ? 0.4 : 0.15 },
    // { field: "createdBy", headerName: "Created By" },
    // {
    //   field: "options",
    //   headerName: "Options",
    //   renderCell: (params) => (
    //     <Grid2 spacing={2}>
    //       <IconButton
    //         onClick={(event) => {
    //           event.stopPropagation();
    //           handleManageUsers();
    //           setSelectedWorkspace(params.row);
    //         }}
    //       >
    //         <img
    //           src={userIcon}
    //           alt="user icon"
    //           style={{ width: '24px', height: '24px' }}
    //         />
    //       </IconButton>
    //       <IconButton
    //       //onClick={() => handleNavigate(params.row._id)}
    //       >
    //         <img
    //           src={editIcon}
    //           alt="edit icon"
    //           style={{ width: '24px', height: '24px' }}
    //         />
    //       </IconButton>
    //       <IconButton

    //         onClick={(event) => {
    //           event.stopPropagation();
    //           handleDeleteWorkspace();
    //           setSelectedWorkspace(params.row);
    //         }}
    //       >
    //         <img
    //           src={deleteIcon}
    //           alt="delete icon"
    //           style={{ width: '24px', height: '24px' }}
    //         />
    //       </IconButton>
    //     </Grid2>
    //   ),
    //   width: 150,
    // },
  ];

  const filteredRows = Array.isArray(workspaces)
    ? workspaces
      .filter((workspace) => {
        const name = workspace?.name || "";
        const createdBy = Array.isArray(workspace?.createdBy)
          ? workspace.createdBy[0]?.name
          : "";
        return (
          name.toLowerCase().includes(searchTerm) ||
          createdBy.toLowerCase().includes(searchTerm)
        );
      })
      .map((workspace, index) => ({
        id: index,
        name: workspace?.name || 'Untitled',
        createdBy: Array.isArray(workspace?.createdBy)
          ? workspace.createdBy[0]?.name || 'N/A'
          : 'N/A',
        _id: workspace._id
      }))
    : [];


  const openModal = () => {
    setModalOpen(true);
  }

  const refreshPage = () => {
    window.location.reload();
  };

  return (
    <Grid2 container spacing={2} alignItems="center" >
      <Grid2 container size={12} display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 4 }}>
        <Grid2 size={{ xs: 12, md: 8 }} display='flex' alignItems="center">
          <Box
            sx={{
              p: 1.5,
              borderRadius: '12px',
              background: 'rgba(99, 102, 241, 0.1)',
              mr: 3,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Box component="img" sx={{ width: { xs: 28, md: 32 } }} src={WorkspaceIcon} />
          </Box>
          <Box>
            <Typography variant={"h1"} sx={{ mb: 0.5 }}>List of workspaces</Typography>
            <Typography variant="body2" color="textSecondary">Manage and organize your project workspaces</Typography>
          </Box>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 4 }} display="flex" justifyContent="flex-end" sx={{ mt: { xs: 2, md: 0 } }}>
          <AddButton
            label="Create Workspace"
            sx={{ boxShadow: '0 10px 15px -3px rgba(99, 102, 241, 0.3)' }}
            onClick={openModal}
          />
        </Grid2>
      </Grid2>
      <Grid2 size={12} container spacing={2} alignItems="center">

        <Grid2 container spacing={2} alignItems="center" sx={{ marginTop: isMobile ? 4 : 0 }}>
          <Grid2 size={12}>
            <Box
              className="glass-card"
              sx={{
                p: 2.5,
                borderRadius: '16px',
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
                flexGrow: 1,
                mb: 3
              }}>
              <Grid2 size={{ xs: 12, md: 5 }}>
                <SearchField
                  placeholder="Search by name or owner..."
                  variant="outlined"
                  fullWidth
                  value={searchTerm}
                  onChange={handleSearch}
                  sx={{ flex: 1 }}
                />
              </Grid2>
            </Box>
          </Grid2>
          <Grid2 size={4}>
          </Grid2>
          <Grid2 size={12}>
            <Paper
              className="glass-panel"
              sx={{
                borderRadius: '16px',
                overflow: 'hidden',
                border: 'none',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)'
              }}
            >
              <Box sx={{ width: "100%", minHeight: 400 }}>
                {columns.length > 0 ?
                  <DataGrid
                    rows={filteredRows}
                    columns={columns}
                    disableColumnSelector
                    disableRowSelectionOnClick
                    initialState={{
                      pagination: {
                        paginationModel: {
                          pageSize: 10,
                        },
                      },
                    }}
                    pageSizeOptions={[10, 25, 50]}
                    onRowClick={handleRowClick}
                    sx={{
                      '& .MuiDataGrid-cell:focus': {
                        outline: 'none',
                      },
                      '& .MuiDataGrid-row:hover': {
                        cursor: 'pointer',
                        backgroundColor: 'rgba(99, 102, 241, 0.02)',
                      },
                      height: 600
                    }}
                  />
                  :
                  <Box sx={{ p: 8, textAlign: 'center' }}>
                    <Typography variant="body1" color="textSecondary">No workspaces found</Typography>
                  </Box>
                }
              </Box>
            </Paper>
          </Grid2>
        </Grid2>
        <WorkspaceModal
          isOpen={modalOpen}
          onClose={() => {
            setModalOpen(false)
          }}
          refreshList={refreshPage}
        />

        {/* <ManageUsersModal
          open={manageUsersModalOpen}
          onClose={() => setManageUsersModalOpen(false)}
          selectedType={selectedWorkspace}
          onSuccess={() => setShouldRefresh(true)}
        />

        <DeleteConfirmationModal
          deleteButtonLabel={'Delete'}
          open={deleteModalOpen}
          onClose={() => setDeleteModalOpen(false)}
          text={
            <>
              <span className="font-normal">Are you sure, you want to delete the workspace </span>
              {`"${selectedWorkspace?.name}" `}
              ?
            </>
          }
          onConfirm={handleDeleteConfirm}
        /> */}
      </Grid2>
      <WorkspaceModal
        isOpen={modalOpen}
        onClose={() => {
          setModalOpen(false)
        }}
        refreshList={() => setShouldRefresh(true)}
      />
      {loading && <LoadingOverlay />}
    </Grid2>
  );
};

export default WorkspaceList;
